import { loadingController, toastController  } from '@ionic/vue';
import { checkmarkCircleOutline, warningOutline,closeCircleOutline } from 'ionicons/icons';
import moment from 'moment';
import axios from 'axios';
import { version } from '../../package.json'

/** Evita spam si la misma asistencia inválida se re-renderiza (módulo, no por llamada a tools()) */
const fechaInvalidaLogged = new Set<string>()

export default function tools() {    

    const toast = async (message:string, color:'success'|'warning'|'danger',duration=2500) =>{
        let icon: string | undefined
        switch(color){
            case 'success': icon = checkmarkCircleOutline; break;
            case 'warning': icon = warningOutline; break;
            case 'danger': icon = closeCircleOutline; break;
        }
        const _toast = await toastController.create({
            message: message,
            duration: duration,
            position: 'top',
            color: color,
            ...(icon ? { icon } : {}),
          });
  
          await _toast.present();
    }

    const delay = async (milliseconds:number)=> {
        return new Promise(resolve => {
          setTimeout(resolve, milliseconds);
        });
  }

   const getImageClase = (src:string) : string => {
    if (src.includes('https://')) {
      return src;
    } else {
      return process.env.VUE_APP_MEDIA_URL + src;
    }
   }

   const getPathImage = (src:string) : string => {
        return process.env.VUE_APP_MEDIA_URL + src    
   }

   
   const showLoading = async (msj:string) => {
    const loading = await loadingController.create({
      message: msj,
    });
    
    loading.present();
  }

  const dismissLoading = () =>{
    loadingController.dismiss()
  }

   const number2day = (numberDay:number) : string => {
    switch(numberDay){
      case 1: return 'Lunes';
      case 2: return 'Martes';
      case 3: return 'Miercoles';
      case 4: return 'Jueves';
      case 5: return 'Viernes';
      case 6: return 'Sábado';
      case 7: return 'Domingo';
      default: return 'undefined';
    }
   }

   const relativeDate = (myDate:Date,conHora=true) : string =>{
      if(conHora)
          return moment(myDate).fromNow()
      else{
        if( moment(myDate).format('YMD') == moment().format('YMD') ) return 'hoy';
        else if( moment(myDate).format('YMD') == moment().add(1,'days').format('YMD') ) return 'mañana';
        else if( moment(myDate).format('YMD') == moment().add(2,'days').format('YMD') ) return 'pasado mañana';
        else if( moment(myDate).format('YMD') == moment().add(-1,'days').format('YMD') ) return 'ayer';
        else if( moment(myDate).format('YMD') == moment().add(-2,'days').format('YMD') ) return 'antes de ayer';
        else if( moment(myDate).diff(moment(),'days' ) < 7) return 'este ' + moment(myDate).format('dddd');
        else if( moment(myDate).diff(moment(),'days' ) >= 7) return ' el próximo ' + moment(myDate).format('dddd') + ' ' + moment(myDate).format('d')
        else return moment(myDate).format('dddd d') + ' de ' + moment(myDate).format('mmmm')
      }
   }

   /**
    * Convierte a texto el nivel de una disciplina
    * @param level 
    * @returns 
    */
   const number2Level = (level:number) : string => {
    switch(level){
      case 0: return 'Básico 0';
      case 1: return 'Básico 1';
      case 2: return 'Básico 2';
      case 3: return 'Intermedio 1';
      case 4: return 'Intermedio 2';
      case 5: return 'Avanzado';
      default: return 'Sin nivel definido';
    }
   }


  const setLog = (event:string,level?: 'warning' | 'info' | 'error' | 'debug') => {
    try {
      // Fire-and-forget: no romper UI ni disparar toast del interceptor si falla el tracking
      return axios.post('log/set',{
        event:event,
        level: level === undefined ? 'info' : level,
        version: 'cli_' + version
      }, { skipErrorToast: true }).catch(() => {
        console.log('No se pudo guardar el log en el servidor para el evento -' + event + '-')
      })
    } catch (error) {
      console.log('No se pudo guardar el log en el servidor para el evento -' + event + '-')
      return Promise.resolve()
    }
  }

  /**
   * Detecta moment inválido en confirmación de asistencia (síntoma UI «Fecha inválida»).
   * Devuelve true si la fecha NO es válida (y deja traza en tracking).
   */
  const logFechaInvalidaAsistencia = (
    contexto: string,
    asistencia: { id?: number; sesionId?: number; fecha?: unknown; timestamp?: unknown },
    extra?: string,
  ): boolean => {
    const raw = asistencia.fecha ?? asistencia.timestamp
    const m = moment(raw as string | Date | null | undefined)
    if (m.isValid()) return false

    const key = `${contexto}:${asistencia.id ?? '?'}:${asistencia.sesionId ?? '?'}:${String(asistencia.timestamp)}:${String(asistencia.fecha)}`
    if (fechaInvalidaLogged.has(key)) return true
    fechaInvalidaLogged.add(key)

    const bits = [
      `Fecha inválida [${contexto}]`,
      asistencia.id != null ? `asistencia #${asistencia.id}` : null,
      asistencia.sesionId != null ? `sesion #${asistencia.sesionId}` : null,
      `timestamp=${JSON.stringify(asistencia.timestamp ?? null)}`,
      `fecha=${JSON.stringify(asistencia.fecha ?? null)}`,
      extra?.trim() || null,
    ].filter(Boolean)
    setLog(bits.join(' · '), 'warning')
    return true
  }

   /*
   * Devuelve el nombre de un usiario contemplando que la primera palabra es el nombre
   */
   const getShortName = (name:string):string => { 
    if(name === '' || name === null || name === undefined ) return name
    //si no tiene espacios, devolvemos el nombre completo
    if(!name.includes(' ')) return name
    const names = name.split(' ')
    if(names.length > 1)
      return names[0]
    else
      return name
    }
  
    /*
    * Devuelve la hora en formato corto sin ceros a la izquierda
    */
    const getShortHour = (hour:string):string => {
      if(hour === '' || hour === undefined || !hour.includes(':') || hour === null ) {
      return hour
      }

      const h = hour.split(':')
      if(h.length > 1 && h[1] === '00') 
        return h[0] + 'h'
      else
        return h[0] + ':' + h[1] + 'h'
    }

    /** Deja solo dígitos y + al inicio (para que coincida con el pattern HTML5 de teléfono) */
    const sanitizarTelefono = (valor: string): string => {
      const sinLetras = valor.replace(/[^\d+]/g, '')
      const plus = sinLetras.startsWith('+') ? '+' : ''
      const digitos = sinLetras.replace(/^\+/, '').replace(/\D/g, '')
      return plus + digitos
    }

    /** Solo dígitos (ignora espacios, guiones y prefijos + / 00) */
    const digitosTelefono = (telefono: string): string => telefono.replace(/\D/g, '')

    /** Mínimo de dígitos para lanzar búsqueda de asistente (sin contar espacios) */
    const telefonoListoParaBuscar = (telefono: string, minimo = 9): boolean =>
      digitosTelefono(telefono).length >= minimo

    /** Comprueba si el valor es un teléfono válido (España: 9 dígitos empezando por 6,7,8,9; internacional: 10-15 dígitos) */
    const esTelefonoValido = (telefono: string): boolean => {
      const digits = digitosTelefono(telefono)
      if (digits.length < 9 || digits.length > 15) return false
      if (digits.length === 9) return /^[6789]/.test(digits)
      return true
    }

    return {
        toast,delay,getImageClase,number2day,getShortName,relativeDate,setLog,logFechaInvalidaAsistencia,getPathImage,showLoading,dismissLoading, getShortHour,number2Level, sanitizarTelefono, digitosTelefono, telefonoListoParaBuscar, esTelefonoValido
    }
  }